import Breadcrumbs from 'components/breadcrumbs';
import LoadingSpinner from 'components/loading-spinner';
import { useGet } from 'hooks/use-get';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import _, { isEmpty } from 'underscore';
import { BluViuNutritionParams } from 'views/bluviu-nutrition/types/bluviu-nutrition-params.type';
import BluViuNutritionTabsHeader from '../../../components/bluviu-nutrition-tabs-header';
import SitesOverview from '../../../components/sites-overview';
import { useBluViuNutritionState } from '../../../context/bluviu-nutrition-context';
import { useSelectedSite } from '../../../hooks/use-selected-site';
import { getScenarios } from '../api/bluviu-nutrition';
import { ScenarioListItem } from '../types/scenario-list-item.type';
import { ScenariosParams } from '../types/scenarios-params.type';
import FilterListScenarios from './filter-list-scenarios';
import ListScenarios from './list-scenarios';
import { Box, Typography } from '@mui/material';

const PAGE_NAME_ID = 'bluViuNutrition.listScenarios';

const ScenariosContent = () => {
  const params = useParams<BluViuNutritionParams>();
  const [searchValue, setSearchValue] = useState<string>('');
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);

  const [rows, setRows] = useState<ScenarioListItem[]>([]);

  const { data, isLoading } = useGet(['getScenarios', params.globalSiteId], ({ queryKey }) => getScenarios(String(queryKey[1])));

  useEffect(() => {
    setRows(
      _.chain(data)
        .filter((item) => (isEmpty(selectedFilters) ? true : _.contains(selectedFilters, item.state)))
        .filter((calibration) => calibration.name.toLowerCase().includes(searchValue.toLowerCase()))
        .sortBy('createdDate')
        .reverse()
        .value()
    );
  }, [data, selectedFilters, searchValue]);

  if (isLoading) return <LoadingSpinner />;
  if (!rows) return;

  return (
    <Box>
      <FilterListScenarios
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        scenarios={rows}
      />
      <ListScenarios scenarios={rows} setScenarios={setRows} />
    </Box>
  );
};

const ScenariosOverview = () => {
  const params = useParams<ScenariosParams>();
  const { selectedSiteId } = useSelectedSite();

  const {
    bluViuNutritionSitesQuery: { data: sites },
  } = useBluViuNutritionState();

  if (!selectedSiteId) {
    return <SitesOverview />;
  }

  return (
    <>
      <BluViuNutritionTabsHeader
        intro={
          <Typography color="white">
            <FormattedMessage id={`general.confidential`} />
          </Typography>
        }
        utils={
          <Breadcrumbs
            crumbs={
              selectedSiteId
                ? [
                    {
                      text: sites?.find((s) => s.globalSiteId === params.globalSiteId)?.siteName || params.globalSiteId,
                      url: ``,
                    },
                  ]
                : undefined
            }
          />
        }
      />
      <ScenariosContent />
    </>
  );
};

export default React.memo(ScenariosOverview);
